import { useSmartAccount } from '~/hooks/useSmartAccounts'
import { BackendTransaction } from '~/types'

export function useRemainingSignatures({
  transaction,
}: {
  transaction: BackendTransaction
}): {
  threshold: number
  remaining: number
  remainingPasskeySigners: number
  remainingEoaSigners: number
} {
  const { smartAccount } = useSmartAccount(transaction.smartAccountAddress)

  // in case still loading
  if (!smartAccount) {
    return {
      threshold: 0,
      remaining: 0,
      remainingPasskeySigners: 0,
      remainingEoaSigners: 0,
    }
  }

  const threshold = smartAccount.threshold
  const remainingPasskeySigners = Math.max(
    0,
    threshold - (transaction.signers?.length ?? 0),
  )
  const remainingEoaSigners = Math.max(
    0,
    threshold - (transaction.eoaSigners?.length ?? 0),
  )
  const remaining = Math.max(
    0,
    threshold -
      ((transaction.signers?.length ?? 0) +
        (transaction.eoaSigners?.length ?? 0)),
  )

  return {
    threshold,
    remaining,
    remainingPasskeySigners,
    remainingEoaSigners,
  }
}
